import { useErrors } from "./useError";
import "./errorToast.css"

// Errors reach the toast from two paths: the global axios interceptor (env.js) forwards the raw
// backend body `{ message, code }`, while call-site handlers (e.g. handleError) pass a plain string.
// Normalize both to a displayable string so neither path renders "[object Object]" or crashes React.
function toMessage(message) {
    if (typeof message === "string") return message
    if (Array.isArray(message)) return message[0]
    return message?.message ?? "Something went wrong"
}

export default function ErrorToasts() {
    const { errors, removeError } = useErrors()

    return (
        <div style={{ position: "fixed", top: 'var(--standard-padding)', right: 'calc(var(--standard-padding) / 2)' }} className="toast-layer">
            {errors.map((err) => (
                <div
                    key={err.id}
                    className="toast-card card filled-error v-spacer-xs interactable flex center gap-xs padding-s showing shadow-elevated"
                    onClick={() => removeError(err.id)}
                >
                    <span className="material-symbols-outlined">error</span>
                    <p className="card-body medium titlecase h-spacer-s">{toMessage(err.message)}</p>
                    <div className="relative close-wrapper">
                        <div className="close-button"><span className="material-symbols-outlined">close</span></div>
                        <div className="circle absolute"></div>
                    </div>
                </div>
            ))}
        </div>
    )
}